import React, { Component } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { API_ENDPOINT, callApi } from "../../utils/api";
import { Link } from "react-router-dom";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore
} from "react-toasts";
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { getExtentUnits } from "../../utils/staticData";

interface AllProps {
  id: any;
  doclist: any;
}
export interface DocList {
  doc_name: string;
  doc_no: string;
  remark: string;
  file_id: string;
  type: string;
  date: string;
  status: string;
  fod_fk: string;
  submit: number;
  inactive: number;
  document_no: string;
  doc_type: string;
  preview_count?: number; // Add preview_count to interface
}
const particularList = [
  {
    label: 'Original',
    value: 'original'
  },
  {
    label: 'Xerox',
    value: 'xerox'
  }
]

export default class DocumentList extends Component<AllProps> {
  // documentBackground = ['#cad8e4', '#d8cae4', '#cde4ca', '#e4d7ca', '#e4caca', '#e0e4ca']
  documentBackground = ['#e2f2ff', '#f9e2ff', '#f4edb2', '#fffbe2', '#ffeee2', '#e8ffe2']
  fromChanged = false;
  toChanged = false;
  timeout: any = null;
  downloadTimer: any = null;
  isMountedDownload = true;

  // Add document property for PDF viewer
  document = {
    base: "",
    numPages: 0,
    pageNumber: 1
  };

  state = {
    overVieWorking: false,
    documentTotal: 0,
    docList: [],
    docIdToBeDeleted: 0,
    reason: "",
    total_extent: "",
    extentUnits: [],
    extent_unit: "",
    pageFrom: '',
    pageTo: '',
    selectedDocumentId: '',
    showCopyConfirm: false,
    inputValidtionError: false,
    errorMessage: '',
    validating: false,
    docNoYear: "",
    categoriesList: [],
    particular: "",
    type: "",
    document: "",
    deeds: [],
    // Add new state properties for PDF viewer
    showPreview: false,
    selectedPreviewDoc: '',
    previewBase: '',
    // Add preview loading state
    previewLoading: false,
    downloadingAll: false,
    downloadSeconds: 0,
  };

  componentDidMount() {
    const extentUnits = getExtentUnits();
    this.setState({ extentUnits });
    this.getDocuments();
    this.getTotalExtent();
    this.setState({ docList: this.props.doclist });
    this.getCategories();
    this.getDeeds();
  }

  componentWillUnmount() {
    this.isMountedDownload = false;
    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
      this.downloadTimer = null;
    }
  }

  startDownloadTimer = () => {
    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
      this.downloadTimer = null;
    }
    this.setState({ downloadingAll: true, downloadSeconds: 0 });
    this.downloadTimer = setInterval(() => {
      this.setState((prevState: any) => ({
        downloadSeconds: (prevState.downloadSeconds || 0) + 1,
      }));
    }, 1000);
  };

  stopDownloadTimer = () => {
    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
      this.downloadTimer = null;
    }
    if (this.isMountedDownload) {
      this.setState({ downloadingAll: false, downloadSeconds: 0 });
    }
  };

  getCategories = () => {
    callApi("POST", "category.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ categoriesList: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getDeeds = () => {
    callApi("POST", "deed_master_get.php", { category: this.state.type })
      .then(res => res.data)
      .then(response => {
        if (response.data && response.data.length) {
          const deeds = response.data;
          this.setState({ deeds });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  getDocType = (category) => {
    console.log("category", category, this.state);
    let Ec_dropdown = [
      {
        "name": "SRO Encumbrance Certificate",
        "id": "SRO Encumbrance Certificate"
      },
      {
        "name": "Online Encumbrance Certificate",
        "id": "Online Encumbrance Certificate"
      },
    ];
    if (category === "ec_doc") {
      this.setState({ deeds: Ec_dropdown })
    } else {
      this.getDeeds();
    }
  };

  handleChangeCategory = (e, propName?, fieldType?) => {
    let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
    let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
    let fieldKey = fieldType === 'singleselect' ? e.id : e.target.name;
    const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', '37', 'Online Encumbrance Certificate'];

    console.log("fieldName--->", fieldName);
    console.log("fieldValue--->", fieldValue);
    console.log("fieldKey----->", fieldKey);

    if (fieldName === "category") {
      // const employee_id = fieldValue;
      this.setState({ type: fieldValue }, () => {
        console.log("handleChangeCategory1", e, this.state);
      });
      this.getDocType(fieldValue);
    }
    if (fieldName === "doc_type") {
      this.setState({ document: fieldValue });
      if (invalidDocuments.includes(fieldValue) || invalidDocuments.includes(fieldKey)) {
        this.setState({ docNoYear: '' }, () => {
          console.log("same");
        });
      }
    }
    if (fieldName === "particular") {
      const bank_name = fieldValue;
      console.log("267", bank_name);
      this.setState({ [fieldName]: fieldValue });
    }
  }

  saveDocNo = (e: any) => {
    this.setState({ docNoYear: e.target.value });
  }

  getDocuments = () => {
    callApi("POST", "doc_list_get.php", { id: this.props.id })
      .then(res => res.data)
      .then(response => {
        let docList = this.state.docList;
        if (response && response.data && response.data.length) {
          docList = response.data;
        }
        this.setState({ docList });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getTotalExtent = () => {
    callApi("POST", "get_total_extent.php", { id: this.props.id })
      .then(res => res.data)
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.setState({ total_extent: response.data[0].total_extend, extent_unit: response.data[0].total_unit });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  getFormUrl = modal => {
    if (modal.type === "ec_doc") {
      return "/ec-form/" + this.props.id + "/" + modal.file_id + '/2';
    } else {
      return "/scrutiny/" + this.props.id + "/" + modal.file_id + '/2';
    }
  };

  confirmDeleteDoc = modal => {
    this.setState({ docIdToBeDeleted: modal.file_id });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  categChange = (e, propName?, fieldType?) => {
    const state: any = this.state;
    let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
    let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
    state[fieldName] = fieldValue;
    this.setState({ ...state });
  };

  deleteDoc = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "scrutiny_delete.php", {
      id: this.state.docIdToBeDeleted,
      userId
    })
      .then(res => res.data)
      .then(response => {
        this.getDocuments();
        this.submitReason();
      })
      .catch(err => {
        console.log(err);
      });
  };

  submitReason = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "reason_create.php", {
      userId,
      action: "delete-document",
      reason: this.state.reason,
      fod_fk: this.state.docIdToBeDeleted
    })
      .then(res => res.data)
      .then(response => {
        this.setState({ docIdToBeDeleted: 0 });
      })
      .catch(err => {
        console.log(err);
      });
  };

  onModifyTotalExtent = () => {
    callApi("POST", "total_extent.php", {
      file_id: this.props.id,
      total_extent: this.state.total_extent,
      extent_unit: this.state.extent_unit
    })
      .then(res => res.data)
      .then(response => {
        // console.log(response);
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleFromPageChange = (event) => {
    const value = event.target.value;
    if (value.match(/^[0-9]+$/) || isEmpty(value)) {
      this.setState({ validating: true });
      if (!this.fromChanged) {
        this.fromChanged = true;
      }
      clearInterval(this.timeout);
      this.timeout = setTimeout(() => {
        this.onInputFocusOut(value, this.state.pageTo);
      }, 500);
      this.setState({ pageFrom: value });
    }
  }

  handleToPageChange = (event) => {
    const value = event.target.value;
    if (value.match(/^[0-9]+$/) || isEmpty(value)) {
      this.setState({ validating: true });
      if (!this.toChanged) {
        this.toChanged = true;
      }
      clearInterval(this.timeout);
      this.timeout = setTimeout(() => {
        this.onInputFocusOut(this.state.pageFrom, value);
      }, 500);
      this.setState({ pageTo: value });
    }
  }

  onInputFocusOut = (pageFrom, pageTo) => {
    if (this.fromChanged && this.toChanged && pageFrom && pageTo) {
      const from = parseInt(pageFrom, 10) || 0;
      const to = parseInt(pageTo, 10) || 0;
      const error = from > to;
      const errorMessage = error ? "From Page should not be greater than To Page" : '';
      this.setState({ inputValidtionError: error, errorMessage }, () => this.setState({ validating: false }));
    } else {
      this.setState({ inputValidtionError: false, errorMessage: '' }, () => this.setState({ validating: false }));
    }
  }

  handleCopyDocumentSubmit = () => {
    const { type, document, docNoYear, selectedDocumentId, pageFrom, pageTo, particular } = this.state;
    const validTypes = ['deed', 'mother_doc', 'title_deed'];
    const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', '37', 'Online Encumbrance Certificate'];
    if ((type === "ec_doc" || validTypes.includes(type)) && docNoYear === '' && (document === "SRO Encumbrance Certificate" || !invalidDocuments.includes(document))) {
      ToastsStore.error("Doc No Year is required for this type of document.");
      return;
    }
    callApi("POST", "copyPdf.php", {
      file_id: selectedDocumentId,
      pageFrom: pageFrom,
      pageTo: pageTo,
      docNoYear: docNoYear,
      category: type,
      doc_type: document,
      particular: particular,
    })
      .then(res => res.data)
      .then(response => {
        const { result, message } = response;
        result ? ToastsStore.success(message) : ToastsStore.error(message);
        this.getDocuments();
        this.handleClosePopup();
      })
      .catch(err => {
        console.log(err);
        ToastsStore.error(err.message || "Something went wrong, please try again later");
      });
  }

  handleClosePopup = () => {
    this.fromChanged = false;
    this.toChanged = false;
    this.setState({ pageFrom: '', pageTo: '', docNoYear: '', type: '', particular: '', selectedDocumentId: '', showCopyConfirm: false, inputValidtionError: false, errorMessage: '' })
  }

  handleCopyDocument = (fileDetails) => {
    this.setState({ selectedDocumentId: fileDetails.file_id, showCopyConfirm: true })
  }

  // Updated viewDocument method with preview logging
  viewDocument = (id) => {
    this.setState({ showPreview: true, previewLoading: true });

    // Get user from localStorage
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";

    // First log the preview
    callApi("POST", "document_preview_update.php", {
      document_id: id,
      user_id: userId
    })
      .then(res => res.data)
      .then(response => {
        console.log("Preview logged:", response);
        // Refresh the document list to update preview count
        this.getDocuments();
      })
      .catch(err => {
        console.log("Failed to log preview:", err);
        // Don't show error to user, just log it
      });

    // Then load the document
    callApi("POST", "getbaseby_id.php", { id })
      .then(res => res.data)
      .then(response => {
        console.log("Document response:", response); // Add this for debugging
        if (response.data && response.data.length > 0 && response.data[0].base && response.data[0].base.length > 0) {
          const baseData = response.data[0].base[0].base;
          this.setState({
            previewBase: baseData,
            selectedPreviewDoc: id,
            previewLoading: false
          });
        } else {
          this.setState({ previewLoading: false });
          ToastsStore.error("No document data found");
        }
      })
      .catch(err => {
        console.log("Error loading document:", err);
        this.setState({ previewLoading: false });
        ToastsStore.error("Failed to load document");
      });
  };

  downloadAll = () => {
    const fileId = this.props.id;
    if (!fileId) {
      ToastsStore.error("File is not available");
      return;
    }
    if (this.state.downloadingAll) {
      return;
    }
    const authKey = localStorage.getItem("authkey");
    this.startDownloadTimer();
    axios
      .post(
        API_ENDPOINT + "download_all_documents.php",
        { id: fileId },
        {
          headers: {
            Authorization: `Bearer ${authKey}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      )
      .then(async (response) => {
        const contentType = String(response.headers["content-type"] || "");
        if (contentType.indexOf("application/json") !== -1) {
          const text = await response.data.text();
          let message = "Download failed";
          try {
            const body = JSON.parse(text);
            if (body && body.message) {
              message = body.message;
            }
          } catch (parseError) {
            console.log(parseError);
          }
          ToastsStore.error(message);
          return;
        }
        const disposition = String(response.headers["content-disposition"] || "");
        const match = /filename="?([^";]+)"?/i.exec(disposition);
        const filename = match && match[1] ? match[1] : "documents.zip";
        saveAs(response.data, filename);
        const skipped = parseInt(String(response.headers["x-skipped-documents"] || "0"), 10) || 0;
        if (skipped > 0) {
          ToastsStore.success(
            "Downloaded. " + skipped + " file(s) were skipped because they are missing."
          );
        }
      })
      .catch(async (err) => {
        console.log(err);
        let message = "Download failed";
        const data = err && err.response && err.response.data;
        if (data && typeof data.text === "function") {
          try {
            const text = await data.text();
            const body = JSON.parse(text);
            if (body && body.message) {
              message = body.message;
            }
          } catch (parseError) {
            console.log(parseError);
          }
        }
        ToastsStore.error(message);
      })
      .then(() => {
        this.stopDownloadTimer();
      });
  };

  // Add closePreview method
  closePreview = () => {
    this.setState({
      showPreview: false,
      previewBase: '',
      selectedPreviewDoc: '',
      previewLoading: false
    });
  }

  render() {
    const validTypes = ['deed', 'mother_doc', 'title_deed'];
    const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', '37', 'Online Encumbrance Certificate'];
    const { type, document, docNoYear, selectedDocumentId, pageFrom, pageTo, particular } = this.state;

    return (
      <div id="step-2">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">File Document</h5>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.downloadAll}
            disabled={this.state.downloadingAll}
          >
            Download All
          </button>
        </div>
        <hr />
        {this.state.downloadingAll && (
          <div className="text-center" style={{ padding: "40px 16px" }}>
            <h4>
              <span>Downloading... {this.state.downloadSeconds} seconds</span>
            </h4>
            <h4>Please wait...</h4>
          </div>
        )}
        <div className="card-body">
          {this.state.docList &&
            this.state.docList.length > 0 &&
            this.state.docList.map((doc: any, ind) => {
              return (
                doc.documents && doc.documents.length ? (
                  <section key={ind} className="all-document-section" style={{ backgroundColor: this.documentBackground[ind] }}>
                    <h5>{doc.type}</h5>
                    <div className="row">
                      {doc.documents && doc.documents.length
                        ? doc.documents.map((itm: DocList, index) => {
                          // Check if document has been previewed - ensure proper number comparison
                          const previewCount = itm.preview_count ? parseInt(itm.preview_count.toString()) : 0;
                          const hasBeenPreviewed = previewCount > 0;

                          return (
                            <a
                              data-toggle="tooltip"
                              title=""
                              className="col-md-3"
                              data-original-title="Sale deed is missing"
                              key={index}
                            >
                              <div
                                className={
                                  itm.inactive === 1 ? "card card-border-c-yellow" :
                                    itm.submit === 1
                                      ? "card card-border-c-green"
                                      : "card card-border-c-red"
                                }
                                style={{ position: 'relative' }} // Add relative positioning for the preview badge
                              >
                                <i className="complete" />

                                {/* Preview Indicator - Only shows when document has been viewed (count > 0) */}
                                {hasBeenPreviewed && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      bottom: '5px',
                                      right: '5px',
                                      backgroundColor: '#28a745',
                                      color: 'white',
                                      padding: '3px 8px',
                                      borderRadius: '12px',
                                      fontSize: '11px',
                                      fontWeight: 'bold',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                      zIndex: 1,
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}
                                  >
                                    <i className="feather icon-check-circle" style={{ fontSize: '12px' }}></i>
                                    <span>Previewed {previewCount > 1 ? `(${previewCount})` : ''}</span>
                                  </div>
                                )}

                                <div className="card-body document-content">
                                  <Link to={this.getFormUrl(itm)} key={index}>
                                    <h5 className="card-title">
                                      {itm.date ? itm.date + "-" + " " : ""}
                                      <span
                                        className={
                                          itm.submit === 1
                                            ? "mb-1 text-c-green"
                                            : "mb-1 text-c-red"
                                        }
                                      >
                                        {itm.doc_no}
                                      </span>
                                    </h5>
                                    {itm.inactive === 1 && <span className="mb-1 text-c-yellow" style={{ fontSize: '22px', fontWeight: 900 }}>NOT RELATED</span>}<br />

                                    <label className="ft-wt-800">{itm.document_no}</label><br />
                                    <label className="ft-wt-800">{itm.doc_type}</label><br />
                                    <label>{itm.remark}</label>
                                  </Link>
                                  <div className="document-content">
                                    <button
                                      type="button"
                                      className="btn btn-icon btn-rounded btn-danger"
                                      data-toggle="modal"
                                      style={{ width: "30px", height: "30px", padding: "5px 8px" }}
                                      onClick={() => this.confirmDeleteDoc(itm)}
                                    >
                                      <i className="feather icon-minus" />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-icon document-copy-icon btn-rounded btn-secondary"
                                      data-toggle="modal"
                                      style={{ width: "30px", height: "30px", padding: "5px 8px" }}
                                      onClick={() => this.handleCopyDocument(itm)}
                                    >
                                      <i className="feather icon-copy" />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-icon document-copy-icon btn-rounded btn-primary"
                                      data-toggle="modal"
                                      style={{ width: "30px", height: "30px", padding: "5px 6px", margin: "0px 10px 0px" }}
                                      onClick={() => this.viewDocument(itm.file_id)}
                                    >
                                      <i className="feather icon-eye" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </a>
                          );
                        })
                        : <div className="col-12 text-center py-3">No documents found in this category</div>}
                    </div>
                  </section>
                ) : null
              );
            })}
        </div>

        {/* Delete Document Modal */}
        <div
          className="modal fade"
          id="delete-document"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Disable Document</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h6>Are you sure you want to disable this document?</h6>
                <div className="form-group">
                  {/* <label>Reason</label> */}
                  <textarea
                    name="reason"
                    className="form-control"
                    onChange={e => this.handleChange(e)}
                    value={this.state.reason}
                    placeholder="Reason"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.deleteDoc}
                >
                  Disable
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Copy Document Modal */}
        <div
          className={`modal fade ${this.state.showCopyConfirm ? 'show d-block' : ''}`}
          id="copy-document-modal"
          role="dialog"
          aria-hidden={!this.state.showCopyConfirm}
          style={{
            display: this.state.showCopyConfirm ? 'block' : 'none',
            backgroundColor: 'rgba(0,0,0,0.5)'
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Copy Document</h5>
                <button
                  type="button"
                  className="close cursor-pointer"
                  aria-label="Close"
                  onClick={this.handleClosePopup}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group document-content">
                  <div className="row">
                    <div className="col-md-6">
                      <input
                        name="pageFrom"
                        className="form-control"
                        onChange={e => this.handleFromPageChange(e)}
                        value={this.state.pageFrom}
                        placeholder="From Page"
                      />
                      {!this.state.pageFrom && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}
                    </div>
                    <div className="col-md-6">
                      <input
                        name="pageTo"
                        className="form-control"
                        onChange={e => this.handleToPageChange(e)}
                        value={this.state.pageTo}
                        placeholder="To Page"
                      />
                      {!this.state.pageTo && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}
                    </div>
                  </div>
                </div>
                {this.state.inputValidtionError && <div className="text-danger">{this.state.errorMessage}</div>}
                <label style={{ marginTop: "2%" }}>Category</label>
                {this.state.categoriesList && this.state.categoriesList.length > 0 && (
                  <Select
                    options={this.state.categoriesList.map((opt: any) => ({ label: opt.name, value: opt.id }))}
                    name="category"
                    value={this.state.categoriesList.find((o: any) => o.value === this.state.type)}
                    placeholder="example: Title Deed"
                    onChange={(e) => this.handleChangeCategory(e, 'category', 'singleselect')}
                  />
                )}
                {!this.state.type && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}

                <label style={{ marginTop: "2%" }}>Document type</label>
                <Select
                  options={this.state.deeds.map((opt: any) => ({ label: opt.name, value: opt.id }))}
                  name="doc_type"
                  value={this.state.deeds.find((o: any) => o.value === this.state.document)}
                  placeholder="Document type"
                  onChange={(e) => this.handleChangeCategory(e, 'doc_type', 'singleselect')}
                />
                {!this.state.document && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}

                {(type === "ec_doc" || validTypes.includes(type)) && (document === "SRO Encumbrance Certificate" || !invalidDocuments.includes(document)) && (
                  <>
                    <label style={{ marginTop: "2%" }}>Doc.No/Year</label>
                    <input
                      className="form-control"
                      name="docNoYear"
                      placeholder="example: 1501/1996"
                      type="text"
                      value={this.state.docNoYear}
                      onChange={e => this.saveDocNo(e)}
                    />
                    {!this.state.docNoYear && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}
                  </>
                )}

                <label style={{ marginTop: "2%" }}>Particular</label>
                <Select
                  options={particularList}
                  name="particular"
                  value={particularList.find((o) => o.value === this.state.particular)}
                  onChange={(e) => this.handleChangeCategory(e, 'particular', 'singleselect')}
                  placeholder="example: Xerox"
                />
                {!this.state.particular && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.handleClosePopup}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleCopyDocumentSubmit}
                  disabled={(isEmpty(this.state.pageFrom) || isEmpty(this.state.pageTo) || this.state.inputValidtionError || this.state.validating || isEmpty(this.state.type) || isEmpty(this.state.document) || isEmpty(this.state.particular))}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Updated Preview Document Modal */}
        <div
          className={`modal fade ${this.state.showPreview ? 'show d-block' : ''}`}
          id="preview-document-modal"
          role="dialog"
          aria-hidden={!this.state.showPreview}
          style={{
            display: this.state.showPreview ? 'block' : 'none',
            backgroundColor: 'rgba(0,0,0,0.5)'
          }}
        >
          <div className="modal-dialog modal-xl" role="document" style={{ maxWidth: '90%' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Document Preview</h5>
                <button
                  type="button"
                  className="close cursor-pointer"
                  aria-label="Close"
                  onClick={this.closePreview}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.previewLoading ? (
                  <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-2">Loading document...</p>
                  </div>
                ) : this.state.previewBase ? (
                  <div>
                    <iframe
                      src={this.state.previewBase}
                      width='100%'
                      height='600px'
                      title="Document Preview"
                      style={{ border: 'none' }}
                    />
                  </div>
                ) : (
                  <div className="text-center p-5">
                    <p>No document to preview</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}